import { t } from 'i18next';

import { TutorButton, TutorMessage } from '@/features/ai-tutor/types';

import LatexText from '@/features/ai-tutor/components/LatexText';

import type { RefObject } from 'react';

interface TutorChatContentProps {
	messages: TutorMessage[];
	messagesEndRef: RefObject<HTMLDivElement | null>;
	onMessageButtonAction: (buttonObj: TutorButton) => boolean | void;
}

const TutorChatContent = ({
	messages,
	messagesEndRef,
	onMessageButtonAction,
}: TutorChatContentProps) => (
	<>
		{messages.map((message, index) => (
			<li
				key={index}
				className="ai-tutor__list-item"
				style={{
					justifyContent: message.sender === 'User' ? 'flex-end' : 'flex-start',
				}}
			>
				{message.sender === 'User' ? (
					<div className="ai-tutor__message-container">
						<div className="ai-tutor__inner-message-container">
							<div className="ai-tutor__user-message">
								<LatexText>{message.text}</LatexText>
							</div>
						</div>
					</div>
				) : (
					<div className="ai-tutor__message-container">
						<div className="ai-tutor__inner-message-container">
							<div className="ai-tutor__bot-message">
								{message.loaderRan ? (
									<div className="ai-tutor__animated-typing">
										{t(`tutor.let_me_think`)}
									</div>
								) : (
									<LatexText>{message.text}</LatexText>
								)}
							</div>
							{message.button && (
								<div className="button-container">
									{message.button
										.filter(
											(btn) =>
												btn.buttonAction !== 'I_DONT_UNDERSTAND_OPTIONS',
										)
										.map((button, i) => (
											<button
												className="ai-tutor__link-button"
												type="button"
												key={i}
												onClick={() => onMessageButtonAction(button)}
											>
												<LatexText>{button.buttonText}</LatexText>
											</button>
										))}
									{message.button.some(
										(btn) => btn.buttonAction === 'ANSWER_OPTIONS',
									) &&
										!message.button.some(
											(btn) => btn.buttonAction === 'HANDLE_ERROR_RESEND',
										) && (
											<button
												className="ai-tutor__link-button"
												type="button"
												onClick={() =>
													onMessageButtonAction({
														buttonText: 'Ik begrijp het niet',
														buttonAction: 'I_DONT_UNDERSTAND_ENABLER',
													})
												}
											>
												Ik begrijp het niet
											</button>
										)}
									{message.button
										.filter(
											(btn) =>
												btn.buttonAction === 'I_DONT_UNDERSTAND_OPTIONS',
										)
										.map((button, idx) => (
											<button
												className="ai-tutor__link-button"
												type="button"
												key={`dont-understand-option-${idx}`}
												onClick={() => onMessageButtonAction(button)}
											>
												<LatexText>{button.buttonText}</LatexText>
											</button>
										))}
								</div>
							)}
						</div>
					</div>
				)}
			</li>
		))}
		<div ref={messagesEndRef} />
	</>
);

export default TutorChatContent;
